import { Pipe, PipeTransform } from '@angular/core';

@Pipe({ name: 'toDicomName' })
export class ToDicomNamePipe implements PipeTransform {
  transform(nameArr: Array<string>): string {
    nameArr.forEach((el) => {
      if (!el) {
        el = "";
      }
    })
    
    let dicomName = nameArr.join("");
    if (dicomName.length > 0) {
      dicomName = nameArr.join('^');
    }
    return dicomName;
  }
}
